import { render, staticRenderFns } from "./roomElectricity.vue?vue&type=template&id=0531e0c8&scoped=true"
import script from "./roomElectricity.vue?vue&type=script&lang=js"
export * from "./roomElectricity.vue?vue&type=script&lang=js"
import style0 from "./roomElectricity.vue?vue&type=style&index=0&id=0531e0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531e0c8",
  null
  
)

export default component.exports